export default {
      id: "reefer-power-off-usage",
      viewBox: "0 0 101 100",
      url: __webpack_public_path__ + "img/icons.svg#reefer-power-off",
      toString: function () {
        return this.url;
      }
    }